// extracted by mini-css-extract-plugin
module.exports = {"modal":"SmsCodeIssueInfoModal_modal__CXCEE"};